export const MAX_UINT256 =
  115792089237316195423570985008687907853269984665640564039457584007913129639935n

export const ETHEREUM_ADDRESS = '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE'

export const HYPERLIQUID_MINIMUM_DEPOSIT = 5
